import { apiClient } from './client';
import type { ApiResponse } from './types';

export interface RenewContractInput {
  contractNo?: string | null;
  planCode: string;
  startAt: string;
  endAt: string;
  graceDays: number;
  suspendDays: number;
  purgeDays: number;
  notes?: string | null;
}

export async function renewContract(tenantId: number, body: RenewContractInput) {
  const r = await apiClient.post<ApiResponse<{ contractId: number }>>(`/tenants/${tenantId}/contracts/renew`, body);
  return r.data.data!;
}
